"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnsupportedOperatorError = void 0;
class UnsupportedOperatorError extends Error {
    constructor(msg) {
        super(msg ? `UnsupportedOperatorError: ${msg}` : "UnsupportedOperatorError");
    }
}
exports.UnsupportedOperatorError = UnsupportedOperatorError;
//# sourceMappingURL=UnsupportedOperatorError.js.map